module.exports = __webpack_public_path__ + "static/media/add.d941e600.svg";